const videoSource12 = [
  {
    id: "video15",
    src: require("./2_1.mp4"),
  },
  {
    id: "video16",
    src: require("./2_2.mp4"),
  },
  {
    id: "video17",
    src: require("./2_3.mp4"),
  },
];

export default videoSource12;
